import type { WordListData } from '@/teoCore/TeoApi';
import type {
  BrandFitCategory,
  BrandFitHandler,
} from '@/teoCore/text/WordListHandler/BrandFitHandler';
import type { PillGroup } from '@/ui/elements/tpi-drawer/TPIDrawer.svelte';

export type BrandFitPillGroup = Omit<PillGroup, 'key'> & { key: BrandFitCategory };

export function createBrandFitPillGroups(bfHandler: BrandFitHandler): BrandFitPillGroup[] {
  const pillGroups: BrandFitPillGroup[] = [
    {
      id: '0',
      key: 'replacements',
      label: 'Corporate Regeln',
      score: undefined,
      used: true,
      pills: [],
    },
    // {
    //   id: '1',
    //   key: 'checks',
    //   label: 'Corporate Empfehlung',
    //   score: undefined,
    //   used: true,
    //   pills: [],
    // },
  ];
  for (const wordList of bfHandler.lists) {
    // if (wordList.relation_type === 5) {
    //   pillGroups[1]!.pills.push(createPill(bfHandler, wordList));
    // } else {
    pillGroups[0]!.pills.push(createPill(bfHandler, wordList));
    // }
  }

  return pillGroups;
}

function createPill(
  bfHandler: BrandFitHandler,
  wordList: WordListData,
): PillGroup['pills'][number] {
  const score = bfHandler.getFoundEntries(wordList).length;
  return {
    id: wordList.id.toString(),
    key: wordList.name,
    type: 'MarkerPillData',
    label: wordList.title,
    value: score,
  };
}
